import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import * as storage from '../../../persistance/storage';

import {isGM, getMyId} from '../../../utils/auth';
import {displayPhone, displayPhoneInput, formatLeadLocation} from '../../../utils/formatting';
import {dynamicSort} from '../../../utils/sort';

import RhinoLoading from '../common/RhinoLoading';
import RhinoModal from '../../common/modal/RhinoModal';
import RhinoSelect from '../../common/inputs/RhinoSelect';
import RhinoConfirm from '../../common/confirm/RhinoConfirm';

import * as authActionCreators from '../../../actions/auth';
import * as commonActionCreators from '../../../actions/common';
import * as leadsActionCreators from '../../../actions/leads';
import * as messagesActionCreators from '../../../actions/messages';
import * as storesActionCreators from '../../../actions/stores';
import * as userActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, authActionCreators, commonActionCreators, leadsActionCreators, messagesActionCreators, storesActionCreators, userActionCreators);

class ListLeads extends React.Component {

	constructor(props) {
		super(props);

    let locationOptions = [
      { display: 'Loading locations...', value: '' },
    ];

    let initValues = false;
    let initEmail = '';
    let initPhone = '';

    const params = window.location.href.split('?').length > 1 ? window.location.href.split('?')[1] : null;
    if(params) {
      const paramArray = params.split('&');

      for(const p of paramArray) {
        if(p.includes('email=')) {
          initEmail = p.replace('email=', '');
          initValues = true;
        } else if(p.includes('phone_number=')) {
          initPhone = displayPhoneInput(p.replace('phone_number=', ''));
          initValues = true;
        } 
      }
    }

    this.state = {
      requestPending: initValues,
      requestCount: null, 
      requestLeadsPending: false,
      sortByOpen: false,
      sortByDisplay: '',

      ipBlock: false, 
      
      // TODO: eliminate
      leadsSearchInput: '',

      locationOptions: locationOptions, 

      firstNameValue: '', 
      lastNameValue: '', 
      soFirstNameValue: '', 
      phoneValue: initPhone, 
      emailValue: initEmail, 
      addressValue: '', 
      customerNumValue: '', 
      locationValue: '', 

      sortParam: '', 

      passwordModelOpen: false, 
      passwordError: false,
      passwordValue: '',

      passwordConfirmOpen: false,
    };

    this.authToken = storage.get('token');

    if(initValues) {
      this.fetchCustomers();
    }
	}

  componentDidMount() {

    // Load locations if not loaded
    if(this.props.stores.locations.length === 0) {

      this.props.fetchLocations()
      .then((respData) => {
        this.props.storeslocationsSave(respData.locations);

        let updatedLocationOptions = [
          { display: 'Location', value: '' },
        ];

        if(respData.locations) {
          for(let i = 0; i < respData.locations.length; i++) {
            let singleLocation = {
              display: respData.locations[i].name,
              value: respData.locations[i].asc_id,
            };
            if(singleLocation.display !== 'Headquarters') {
              updatedLocationOptions.push(singleLocation);
            }
          }
        }

        this.setState({ locationOptions: updatedLocationOptions });

      })
      .catch((errorResp) => {
        console.error(errorResp);
      });
    } else {

      let locationOptions = [
        { display: 'Location', value: '' },
      ];

      for(let i = 0; i < this.props.stores.locations.length; i++) {
        let singleLocation = {
          display: this.props.stores.locations[i].name,
          value: this.props.stores.locations[i].asc_id,
        };
        if(singleLocation.display !== 'Headquarters') {
          locationOptions.push(singleLocation);
        }
      }

      this.setState({ locationOptions: locationOptions });
    }

    // Check if second auth needed
    if(!this.props.auth.secondAuth) {
      this.openPasswordModal();
    }
  }

  fetchCustomers() {

    this.setState({ 
      requestPending: true,
      requestCount: null, 
      ipBlock: false, 
    });

    const leadsFilter = {
      page: 1,
      limit: 50,
    };

    if(this.state.firstNameValue) {
      leadsFilter.firstName = this.state.firstNameValue.trim();
    }
    if(this.state.lastNameValue) {
      leadsFilter.lastName = this.state.lastNameValue.trim();
    }
    if(this.state.soFirstNameValue) {
      leadsFilter.significantOtherName = this.state.soFirstNameValue.trim(); 
    }
    if(this.state.phoneValue) {
      leadsFilter.phone = this.state.phoneValue.trim();
    }
    if(this.state.emailValue) {
      leadsFilter.email = this.state.emailValue.trim();
    }
    if(this.state.addressValue) {
      leadsFilter.address = this.state.addressValue.trim();
    }
    if(this.state.customerNumValue) {
      leadsFilter.customerNumber = this.state.customerNumValue.trim();
    }
    // if(this.state.locationValue) {
    //   leadsFilter.location_num = this.state.locationValue;
    // }
    if(this.state.sortParam) {
      leadsFilter.sortAttribute = this.state.sortParam;
      leadsFilter.direction = 'ASC';
    }

    this.props.fetchLeads(leadsFilter)
    .then((respData) => {
      this.setState({ 
        requestPending: false,
        requestCount: respData.count, 
      });
      this.props.leadsSave(respData.data);
    })
    .catch((respErr) => {
      this.props.leadsSave(null);
      if(respErr && respErr.ip) {
        this.setState({ 
          requestPending: false,
          requestCount: null, 
          ipBlock: true, 
        });
        this.props.commonAlert('Please connect to a Diamonds Direct store network to complete your search');
      } else {
        this.setState({ 
          requestPending: false,
          requestCount: null, 
        });
      }
    });

  }

  cloneArray(source) {
    let result = [];
    if(!source) { return result; }
    for(let n = 0; n < source.length; n++) {
      result[n] = source[n];
    }
    return result;
  }

  toggleSortByMenu() {
    this.setState({ sortByOpen: !this.state.sortByOpen });
  }

  selectSort(displayValue, sortParam) {

    let currentSort = this.state.sortByDisplay;

    if(this.state.sortByDisplay != displayValue) {
      this.setState({ 
        sortByDisplay: displayValue,
        sortParam: sortParam, 
      }, () => {
        this.fetchCustomers();
      });
    } else {
      this.setState({ 
        sortByDisplay: null, 
        sortParam: '', 
      }, () => {
        this.fetchCustomers();
      });
    }
  }

  exportLeads() {
    this.setState({ requestLeadsPending: true });

    const leadsFilter = {};

    if(this.state.firstNameValue) {
      leadsFilter.first_name = this.state.firstNameValue.trim();
    }
    if(this.state.lastNameValue) {
      leadsFilter.last_name = this.state.lastNameValue.trim();
    }
    if(this.state.soFirstNameValue) {
      leadsFilter.so_first_name = this.state.soFirstNameValue.trim(); 
    }
    if(this.state.phoneValue) {
      leadsFilter.phone = this.state.phoneValue.trim();
    }
    if(this.state.emailValue) {
      leadsFilter.email = this.state.emailValue.trim();
    }
    if(this.state.addressValue) {
      leadsFilter.address = this.state.addressValue.trim();
    }
    if(this.state.customerNumValue) {
      leadsFilter.customer_number = this.state.customerNumValue.trim();
    }
    if(this.state.locationValue) {
      leadsFilter.location_num = this.state.locationValue;
    }
    if(this.state.sortParam) {
      leadsFilter.sort = this.state.sortParam;
    }

    leadsFilter.limit = 1000
    leadsFilter.offset = 0

    this.props.leadsExport(leadsFilter, this.authToken)
    .then((respData) => {
      // this.props.leadsSave(respData.cards);
      this.props.messagesShowConfirmation('Customer export sent');
    })
    .catch((errorResp) => {
      this.setState({ requestLeadsPending: false });
      console.error(errorResp);
    }); 
  }

  userNav(page) {
    history.push('/' + page);
  }

  getSortedLeads() {
    if(this.props.leads.leadsResults === null) {
      return [];
    }

    let filtered = this.getFilteredResult(this.props.leads.leadsResults);

    return filtered;
  }

  changeSearchInput(evt) {
    this.setState({ leadsSearchInput: evt.target.value });
  }

  getFilteredResult() {

    if(!this.props.leads.leadsResults) {
      return [];
    }
    return this.props.leads.leadsResults;
  }

  changeFirstName(evt) {
    this.setState({ firstNameValue: evt.target.value });
  }

  changeLastName(evt) {
    this.setState({ lastNameValue: evt.target.value });
  }

  changeSoFirstName(evt) {
    this.setState({ soFirstNameValue: evt.target.value });
  }

  changePhone(evt) {
    this.setState({ phoneValue: displayPhoneInput(evt.target.value) });
  }

  changeEmail(evt) {
    this.setState({ emailValue: evt.target.value });
  }

  changeAddress(evt) {
    this.setState({ addressValue: evt.target.value });
  }

  changeCustomerNumber(evt) {
    this.setState({ customerNumValue: evt.target.value });
  }

  changeLocation(evt) {
    this.setState({locationValue: evt.target.value});
  }

  formatLeadLocation(storeNum) {
    if(!storeNum) {
      return '';
    }
    for(const loc of this.props.stores.locations) {
      if(parseInt(loc.asc_id) === parseInt(storeNum)) {
        return loc.name;
      }
    }
    return '';
  }

  getSpouseName(spouseObj) {
    const first = spouseObj.first_name ? spouseObj.first_name : '';
    const last = spouseObj.last_name ? spouseObj.last_name : '';

    return first ? `${first} ${last}` : `${last}`;
  }

  closePasswordModal() {
    this.setState({ passwordModelOpen: false });
  }

  changePasswordValue(evt) {
    this.setState({ passwordValue: evt.target.value });
  }

  openPasswordModal() {
    this.setState({ passwordModelOpen: true }, () => {
      // this.props.commonAlert("We appreciate your continued engagement with the DDApp. However, due to the recent implementation of our new CRM system, adding new customers directly through the DDApp is temporarily unavailable.<br /><br />To add new customers and ensure accurate record-keeping, we kindly request that you utilize the new CRM system.<br /><br />This transition is designed to enhance your experience and enable us to better serve you. If you require any assistance platform, our support team is available to help.", {
      //   linkLabel: 'Contact Support',
      //   linkFullSrc: 'mailto:CRMSupport@diamondsdirect.com',
      // });
    });
  }

  submitPasswordValidation() {

    if(!this.state.passwordValue) {
      return;
    }

    this.props.userValidatePassword({ password: this.state.passwordValue })
    .then((respData) => {
      this.props.authSetSecondAuth(); 
      this.setState({ 
        passwordError: false,
        passwordValue: '',
        passwordModelOpen: false,
      });
      if(respData.auth.need_password_reset) {
        history.push('/update-password');
      }
    })
    // .catch((errData) => {
    //   this.setState({ passwordError: true });
    // });
  }

  nullMethod() {

  }

  togglePasswordConfirm() {
    this.setState({ passwordConfirmOpen: !this.state.passwordConfirmOpen });
  }

  sendPasswordReset() {

    let userData = {
      id: getMyId(),
    }
    
    this.props.usersAdminPasswordReset(userData)
      .then((respData) => {
        this.togglePasswordConfirm();
        this.props.commonAlert('Password reset sent');
      })
      .catch((errorData) => {
        this.setState({
          serverError: errorData.message
        });
      });
  }

	render() {
		return <div className='ListLeads'>
      <div className='leadsControl'>
        <div className='sortControlWrapper'>
          
          <div className='sortByLabel' onClick={this.toggleSortByMenu.bind(this)} ref={(sortByLabel) => { this.sortByLabel = sortByLabel; }}>
            Sort By
            <div className={this.state.sortByOpen ? 'sortByMenu resultsMenu open' :  'sortByMenu resultsMenu'} ref={(sortByMenuBody) => { this.sortByMenuBody = sortByMenuBody; }}>
              <div className='menuInnerWrapper'>
                <div 
                  className={this.state.sortByDisplay == 'First Name' ?  'menuEntry selected' : 'menuEntry'} 
                  onClick={() => this.selectSort('First Name', 'first_name')}>
                  <div className='selectCheck'><i className="fas fa-check"></i></div>First&nbsp;Name
                </div>
                <div 
                  className={this.state.sortByDisplay == 'Last Name' ?  'menuEntry selected' : 'menuEntry'} 
                  onClick={() => this.selectSort('Last Name', 'last_name')}>
                  <div className='selectCheck'><i className="fas fa-check"></i></div>Last&nbsp;Name
                </div>
                {isGM() && false ?
                  <div 
                    className={this.state.sortByDisplay == 'Sales Associate' ?  'menuEntry selected' : 'menuEntry'} 
                    onClick={() => this.selectSort('Sales Associate', 'sales_associate')}>
                    <div className='selectCheck'><i className="fas fa-check"></i></div>Sales&nbsp;Associate
                  </div> :
                  null
                }
              </div>
            </div>
          </div>
          {this.state.sortByDisplay ?
            <div className='sortByDisplay' onClick={this.toggleSortByMenu.bind(this)} ref={(sortByDisplay) => { this.sortByDisplay = sortByDisplay; }}>{this.state.sortByDisplay}</div> :
            null
          }
          <div className='sortByArrow' onClick={this.toggleSortByMenu.bind(this)} ref={(sortByArrow) => { this.sortByArrow = sortByArrow; }}>
            <img src='/img/results/arrow.svg' />
          </div>
        </div>
        {/*<div className={'actionButton sendMessageButton'} disabled={this.getSortedLeads().length === 0 || this.state.requestLeadsPending} onClick={this.exportLeads.bind(this)} style={{display: 'none'}}>Export (CSV)</div>
        <div className={'actionButton sendMessageButton miniButton'} disabled={this.getSortedLeads().length === 0 || this.state.requestLeadsPending} onClick={this.exportLeads.bind(this)} style={{display: 'none'}}>Export</div>*/}
      </div>
      <div className='leadsSearch'>
        <div className='searchLabel'>Search Customers</div>
        <div className='inputWrapper'>
          <input 
            type='text' 
            autocomplete='off'
            placeholder='First name' 
            value={this.state.firstNameValue} 
            onChange={this.changeFirstName.bind(this)} />
        </div>
        <div className='inputWrapper'>
          <input 
            type='text' 
            autocomplete='off'
            placeholder='Last name' 
            value={this.state.lastNameValue} 
            onChange={this.changeLastName.bind(this)} />
        </div>
        <div className='inputWrapper'>
          <input 
            type='email' 
            autocomplete='off'
            placeholder='Email address' 
            value={this.state.emailValue} 
            onChange={this.changeEmail.bind(this)} />
        </div>
        <div className='inputWrapper'>
          <input 
            type='text' 
            autocomplete='off'
            placeholder='Phone number' 
            value={this.state.phoneValue} 
            onChange={this.changePhone.bind(this)} />
        </div>
        <div className='inputWrapper' style={{ display: 'none' }}>
          <RhinoSelect
            selectClass={this.state.locationError ? 'profileSelect error' : 'profileSelect'}
            required={true}
            value={this.state.locationValue} 
            options={this.state.locationOptions}
            changeMethod={(evt) => this.changeLocation(evt)}
            blurMethod={this.nullMethod.bind(this)}
            error={this.state.locationError} />
        </div>
        <div className='inputWrapper'>
          <input 
            type='text' 
            autocomplete='off'
            placeholder='Customer number' 
            value={this.state.customerNumValue} 
            onChange={this.changeCustomerNumber.bind(this)} />
        </div>
        <div className='inputWrapper'>
          <input 
            type='text' 
            autocomplete='off'
            placeholder='Address' 
            value={this.state.addressValue} 
            onChange={this.changeAddress.bind(this)} />
        </div>
        <div className='inputWrapper'>
          <input 
            type='text' 
            autocomplete='off'
            placeholder='Significant other name' 
            value={this.state.soFirstNameValue} 
            onChange={this.changeSoFirstName.bind(this)} />
        </div>
        <div className={'inputWrapper fullWidth'}>
          <button 
            type='button' 
            className={'searchLeadsButton actionButton'}
            onClick={this.fetchCustomers.bind(this)}>
            Search
          </button>
        </div>
      </div>
      <div className='leadsWrapper'>
        {this.state.requestPending ?
          <div className='loadingWrapper'>
            <RhinoLoading message='Loading customers' />
          </div> :
          <div>
            {this.getSortedLeads().length === 0 ?
              <div className='nullLeads'>
                {this.state.ipBlock ?
                  <div>Please connect to a Diamonds Direct store network to complete your search</div> :
                  <div>
                    {this.props.leads.leadsResults === null ? 'Use filters above to search customers' : 'No customers found'}
                  </div>
                }
              </div> :
              <div className='leadsListWrapper'>
                {this.state.requestCount !== null ?
                  <div className='leadsCountWrapper'>{this.state.requestCount} {this.state.requestCount === 1 ? 'result' : 'results'}</div> :
                  null
                }
                {this.getSortedLeads().map((lead, i) => {
                  return <div className={'leadEntry'} key={i}>
                    <div className='leadBody'>
                      <div className='leadName'>{lead.firstName + ' ' + lead.lastName}</div>
                      
                      <div className='leadData'>
                        <div className='leadLabel'>Customer #:</div>
                        <div className='leadValue'>{lead.textCustomField25}</div>
                      </div>
                      {lead.details && lead.details.assigned_sales_person_id ?
                        <div className='leadData'>
                          <div className='leadLabel'>Salesperson #:</div>
                          <div className='leadValue'>{lead.details.assigned_sales_person_id}</div>
                        </div> :
                        null
                      }
                      <div className='leadData'>
                        <div className='leadLabel'>Email:</div>
                        <div className='leadValue'>{lead.email}</div>
                      </div>
                      <div className='leadData'>
                        <div className='leadLabel'>Phone #:</div>
                        <div className='leadValue'>{lead.mobile}</div>
                      </div>
                      <div className='leadData' style={{ display: 'none' }}>
                        <div className='leadLabel'>Location:</div>
                        <div className='leadValue'>{''}</div>
                      </div>
                      
                      <div className='leadCityState' style={{ display: 'none'}}>
                        <div className='addressTitle'>Address:</div>
                        <div>{lead.address}</div>
                        <div className='leadData'>
                          <div className='leadLabel'>Spouse:</div>
                          <div className='leadValue'>{lead.significant_other_name}</div>
                        </div>
                        
                      </div>
                    </div>
                    <div className='leadAction' onClick={() => this.userNav('customer/view/' + lead.id)}>View</div>
                  </div>
                })}
              </div>
            }
          </div>
        }
      </div>
      <div className='buttonWrapper' style={{ display: 'none' }}>
        <div className={'leadsSubmit bottomAction'} onClick={() => this.userNav('search-customers')}>
          New Search
        </div>
        <div className='bottomActionSpacer'></div>
      </div>
      <RhinoModal
        open={this.state.passwordModelOpen}>
        <div className='transferModal'>
          <div className='closeModal' onClick={this.closePasswordModal.bind(this)}>&times;</div>
          <div className='transferModalTitle'>Enter DD App Password</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          {this.state.passwordError ? 
            <div className='errMessage'>User not validated</div> :
            null
          }
          <div className='transferModalInput'>
            <input
              type='password'
              onChange={this.changePasswordValue.bind(this)}
              value={this.state.passwordValue}
              placeholder='Enter Password' />
          </div>
          <div className='transferModalForgotLinkLine'>
            <span className='transferModalForgotLink' onClick={this.togglePasswordConfirm.bind(this)}>Forgot your DDapp password?</span>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={this.submitPasswordValidation.bind(this)}>Submit Request</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoConfirm
        confirmText='Are you sure you want to reset your password?'
        confirmMethod={this.sendPasswordReset.bind(this)}
        cancelMethod={this.togglePasswordConfirm.bind(this)}
        open={this.state.passwordConfirmOpen} />
    </div>;
	}
}
export default ListLeads;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    leads: state.leads,
    stores: state.stores, 
  };
}

export const ListLeadsContainer = connect(
  mapStateToProps,
  allActionCreators
)(ListLeads);